import { render, staticRenderFns } from "./DrinkFreeDaysPanel.vue?vue&type=template&id=4add0b41&scoped=true&"
import script from "./DrinkFreeDaysPanel.vue?vue&type=script&lang=ts&"
export * from "./DrinkFreeDaysPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add0b41",
  null
  
)

export default component.exports